// extracted by mini-css-extract-plugin
module.exports =  {"root":"tSveX3WMGEDIbqTUgv80","defaultImage":"txoncq5tWyjkrZiRF2en","flightImage":"pRNai33RgqLmKINKEN6q"};